import { Selector } from '@ngxs/store';
import { DeviceInfo } from '@capacitor/device';

import { ApplicationState, ApplicationStateModel } from './application.state';

export class ApplicationGetterState {
  @Selector([ApplicationState])
  static getAppState(state: ApplicationStateModel): ApplicationStateModel {
    return state;
  }

  @Selector([ApplicationState])
  static getDeviceInfo(state: ApplicationStateModel): DeviceInfo {
    return state.deviceInfo;
  }

  @Selector([ApplicationState])
  static getIsRealMobileDevice(state: ApplicationStateModel): boolean {
    const deviceInfo = state.deviceInfo;
    return deviceInfo &&
      !deviceInfo.isVirtual &&
      deviceInfo.platform &&
      deviceInfo.platform !== 'web';
  }

}
